import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import { useParams } from "react-router-dom";
import queryFn from "ApiLayer/BuildingReports/Project/queryAnnualCashFlowChart";

export const useAnnualCashFlowChart = (carbonReductionMeasureUid: string) => {
    const accessToken = useAccessToken();
    const { buildingModelUid } = useParams();
    if (!buildingModelUid) throw new Error("BuildingModelUid param needs to be defined");

    return useQuery({
        queryKey: [
            buildingModelUid,
            "buildingModelReport",
            carbonReductionMeasureUid,
            "projectReportAnnualCashFlowChart",
        ],
        queryFn: async () => queryFn(accessToken, carbonReductionMeasureUid),
        staleTime: QUERY_STALE_TIME,
    });
};
